import { ChannelHeaderProps } from "../ChannelHeaderProps";
import React, { useContext } from "react";
import { ConfigContext } from "@mediaspace/shared/data-kms-config";
import { TruncateWithTooltip } from "@mediaspace/shared/ui";
import { translate, useMediaQuery } from "@mediaspace/shared/utils";
import { useTheme } from "@mediaspace/shared/styled";
import styled from "@emotion/styled";
import { Typography } from "@kaltura/ds-react-components";
import Links from "../links/Links";
import { Theme } from "@mui/material";
import { kafSystemWidth } from "@mediaspace/shared/styled";

export type LeanChannelHeaderProps = Pick<ChannelHeaderProps,
    'name' | 'newRowLink' | 'newRowText' | 'newRowClass' | 'newRowDisabled' | 'newrowOpenNewTab' | 'externalLink' | 'externalLinkLabel' | 'externalLink2' | 'externalLinkLabel2' | 'safariSupport' | 'mobileSupport'
>;

/**
 * Lean channel page header
 * Render only channel name and links
 * Used in KAF media gallery when channelHeaderType is set to no banner
 */
export const StyledLeanHeaderContainer = styled("div")(({ theme }) => ({
    "&": kafSystemWidth({ theme }),
    paddingTop: theme.spacing(3),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        flexDirection: 'column',
        alignItems: 'start',
        gap: theme.spacing(2)
    },
}));

export function LeanChannelHeader(props: LeanChannelHeaderProps) {
    const {
        name,
        ...linksProps
    } = props;

    const configContext = useContext(ConfigContext);
    const isKaf = configContext.application?.isKAF;

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

    const channelName = !isKaf ? name : translate('Media Gallery');

    return (
        <StyledLeanHeaderContainer className={"kms-ds-channel-page-lean-header"}>
                <TruncateWithTooltip text={channelName} lines={3}>
                    <Typography
                        className={"kms-ds-channel-page-lean-header-text"}
                        component={"h2"}
                        variant={
                            isSmallScreen ? "h3" : "h2"
                        }
                    >
                        {channelName}
                    </Typography>
                </TruncateWithTooltip>
            <Links {...linksProps} />
        </StyledLeanHeaderContainer>
    );
}

export default LeanChannelHeader;
